module.exports = __webpack_public_path__ + "media/audio10.b63a918f.mp3";